import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface RateAdjustmentCaseSearch {
  corporateNumber: string;
  corporateName: string;
  merchantName: string;
  contractRoute: number;
  includeMerchantCompany: string;
  serviceName: string;
  industry: string;
  handlingProducts: string;
  responseDateStart: string;
  responseDateEnd: string;
  salesStart: number;
  salesEnd: number;
  timestamp: number;
}

const initialState = {} as RateAdjustmentCaseSearch;

const rateAdjustmentCasesSearchConditionSlice = createSlice({
  name: "rateAdjustmentCasesSearchCondition",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<RateAdjustmentCaseSearch>
    ) => {
      const {
        corporateNumber,
        corporateName,
        merchantName,
        contractRoute,
        includeMerchantCompany,
        serviceName,
        industry,
        handlingProducts,
        responseDateStart,
        responseDateEnd,
        salesStart,
        salesEnd,
        timestamp,
      } = action.payload;
      state.corporateNumber = corporateNumber;
      state.corporateName = corporateName;
      state.merchantName = merchantName;
      state.contractRoute = contractRoute;
      state.includeMerchantCompany = includeMerchantCompany;
      state.serviceName = serviceName;
      state.industry = industry;
      state.handlingProducts = handlingProducts;
      state.responseDateStart = responseDateStart;
      state.responseDateEnd = responseDateEnd;
      state.salesStart = salesStart;
      state.salesEnd = salesEnd;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } =
  rateAdjustmentCasesSearchConditionSlice.actions;

export default rateAdjustmentCasesSearchConditionSlice.reducer;
